import { createFileRoute } from '@tanstack/react-router';
import CircuitEdit from '~/containers/CircuitEdit';

export const Route = createFileRoute('/circuits/$circuitId')({
  component: CircuitEdit,
  validateSearch(search): { from?: string } {
    return {
      from: (search.from as string) || undefined,
    };
  },
});
